export const MINI_HEADER_ID = "appHeader"
export const SUB_HEADER_PORTAL_ID = "subHeaderPortalAnchor"
